import { serializable, alias, object, list, primitive } from "serializr";
import { Branches } from "../InstituteModel/branches.model";
 import { Institutes } from "../InstituteModel/institutes.model";

class Section {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("branchClassRoomId", primitive()))
  branchClassRoomId?: number;
}
class ClassRoom {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;
}

class Board {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("acronym", primitive()))
  acronym?: string;

  @serializable(alias("name", primitive()))
  name?: string;
}

export class Students {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("emailId", primitive()))
  email?: string;

  @serializable(alias("phoneNumber", primitive()))
  phoneNumber?: string;

  @serializable(alias("dob", primitive()))
  dob?: string;

  @serializable(alias("start_date", primitive()))
  startDate?: string;
  
  @serializable(alias("end_date", primitive()))
  endDate?: string;

  @serializable(alias("rollNumber", primitive()))
  rollNumber?: string;

  @serializable(alias("is_blocked", primitive()))
  isBlocked?: number | boolean;

  @serializable(alias("blocked_reason", primitive()))
  blockedReason?: string;

  @serializable(alias("classRoomName", primitive()))
  classRoomName?: number | boolean;

  @serializable(alias("classRoom", object(ClassRoom)))
  classRoom?: ClassRoom;

  @serializable(alias("branch", object(Branches)))
  branch?: Branches;

  @serializable(alias("board", object(Board)))
  board?: Board;

  @serializable(alias("section", object(Section)))
  section?: Section;
}

export class UpdateStudents {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("first_name", primitive()))
  firstName?: string;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("dob", primitive()))
  dob?: string;

  @serializable(alias("is_blocked", primitive()))
  isBlocked?: number | boolean;

  @serializable(alias("section_id", primitive()))
  sectionId?: number ;

  @serializable(alias("roll_number", primitive()))
  rollNumber?: string;

  @serializable(alias("course_id", primitive()))
  courseId?: number;
  
  @serializable(alias("subscription_start_date", primitive()))
  startDate?: string;

  @serializable(alias("subscription_end_date", primitive()))
  endDate?: string;
}

export class CreateStudent {
  @serializable(alias("first_name", primitive()))
  firstName?: string;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("roll_number", primitive()))
  rollNumber?: string;

  @serializable(alias("dob", primitive()))
  dob?: string;

  @serializable(alias("is_blocked", primitive()))
  isBlocked?: number | boolean;

  @serializable(alias("section_id", primitive()))
  sectionId?: number ;

  @serializable(alias("password", primitive()))
  password?: string;

  @serializable(alias("course_id", primitive()))
  courseId?: number;
  
  @serializable(alias("subscription_start_date", primitive()))
  startDate?: string;

  @serializable(alias("subscription_end_date", primitive()))
  endDate?: string;
}

export class StudentsDetails {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("first_name", primitive()))
  name?: string;

  @serializable(alias("dob", primitive()))
  dob?: string;

  @serializable(alias("roll_number", primitive()))
  rollNumber?: string;

  @serializable(alias("board", object(Board)))
  board?: Board;

  @serializable(alias("institute", object(Institutes)))
  institute?: Institutes;

  @serializable(alias("branch", object(Branches)))
  branch?: Branches;

  @serializable(alias("class_room", object(ClassRoom)))
  classRoom?: ClassRoom;

  @serializable(alias("section", object(Section)))
  section?: Section;

  // @serializable(alias("parent", object(Parent)))
  // parent?: Parent;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("is_blocked", primitive()))
  isBlocked?: number | boolean;
}


export class FilterStudent {
  @serializable(alias('BoardId', primitive()))
  BoardId?: number;

  @serializable(alias('GradeId', primitive()))
  GradeId?: number;

  // @serializable(alias('search', primitive()))
  // search?: string;

  @serializable(alias('CurrentPage', primitive()))
  CurrentPage?: number;

  @serializable(alias('Pagesize', primitive()))
  Pagesize?: number;

}
